import { useAppSelector } from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import { productAdderStepState } from '@src/stores/product';
import styled, { css } from 'styled-components';
import { device } from '@src/common/breakpoints';
import React, { FC, memo, ReactNode, useMemo } from 'react';
import { Box } from '@planne-software/uni/mui/material';
import usePackageIdParam from '@src/hooks/usePackageIdParam';
import useFeatureFlag from '@src/hooks/useFeatureFlag';

export const AdderContainer: FC<{ children: ReactNode; isMultiProductFlow?: boolean }> = ({
  children,
  isMultiProductFlow = false,
}) => {
  const widgetId = useWidgetId();
  const { currentStep } = useAppSelector(productAdderStepState(widgetId));
  const packageId = usePackageIdParam();

  const { isFeatureFlagEnabled } = useFeatureFlag();

  const isNewSeatmap = useMemo(() => isFeatureFlagEnabled('PR-3221-seat-map'), [isFeatureFlagEnabled]);

  return (
    <StyledAdderContainer
      $isNewSeatmap={isNewSeatmap && currentStep === 'seat_map'}
      $isSeatMap={currentStep === 'seat_map'}
      $isMultiProduct={Boolean(packageId) || isMultiProductFlow}
    >
      {children}
    </StyledAdderContainer>
  );
};

const StyledAdderContainer = styled(Box)<{ $isNewSeatmap: boolean; $isSeatMap: boolean; $isMultiProduct: boolean }>`
  margin: auto;
  width: 100%;

  max-height: fit-content;

  box-sizing: border-box;
  overflow: hidden;

  transition: max-width 0.3s ease-in-out;

  ${device.smallTablet} {
    margin: ${({ $isNewSeatmap }) => ($isNewSeatmap ? '0px' : '50px auto')};
  }

  ${({ $isMultiProduct, $isSeatMap, $isNewSeatmap }) =>
    $isMultiProduct
      ? css`
          max-width: 100%;

          @media (min-width: 600px) {
            max-width: ${$isNewSeatmap ? '100%' : $isSeatMap ? '758px' : '627px'};
          }

          @media (min-width: 900px) {
            max-width: ${$isNewSeatmap ? '100%' : $isSeatMap ? '1034px' : '903px'};
          }
        `
      : css`
          max-width: ${$isNewSeatmap ? '100%' : $isSeatMap ? '1024px' : '627px'};
        `}
`;

export default memo(AdderContainer);
